<div class="wrapper wrap">
    <h1 class="pageTitle">{{ pageTitle }}</h1>
    <div [innerHTML]="guidanceMsg"></div>
    <div style="width: 100%; padding: 0% !important;">
        <div class="card mt-4 bb-panel" *ngIf="checkPermitForm">
            <form [formGroup]="checkPermitForm">
                <div class="form-group">
                    <label for="registration"><span aria-hidden="true" class="form-field-required-marker">
                        *</span> Please enter your vehicle registration</label>

                    <div class="row ml-0 mr-0">
                        <div class="col-sm-8 search-padding">
                            <input id="registration" (keydown.space)="$event.preventDefault()"
                                (keydown.spacebar)="$event.preventDefault()" type="text" class="form-control"
                                formControlName="registration" aria-required="true"
                                oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()" />
                        </div>
                        <button type="button" class="btn btn-primary col-sm-4 mb-0 send-verification-btn search-button"
                            [disabled]="!checkPermitForm.get('registration')?.value" (click)="sendVerification()">
                            Send verification code
                        </button>
                    </div>
                    <div *ngIf="checkPermitForm.get('registration')">
                        <div *ngIf="checkPermitForm.get('registration')?.errors?.regNotFound" role="alert" tabindex="0"
                            class="invalid-feedback">
                            {{ checkPermitForm.get('registration')?.errors?.regNotFound }}
                        </div>
                        <div *ngIf="sent" class="invalid-feedback" style="color:#008000;">
                            <div role="alert" tabindex="0">
                                Your verification code has been emailed to the email address on your permit
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="questionLabel" for="verificationCode">Verification Code</label>
                    <br>
                    <span id="verificationCodeHint">
                        Based on the vehicle registration you have entered, we will email you a verification code to the
                        email address assigned to the permit.
                        <br>
                        <br>
                        <span aria-hidden="true" class="form-field-required-marker">
                            *</span> Please enter your verification code (case sensitive)
                    </span>
                    <div class="row ml-0 mr-0">
                        <div class="col-sm-8 search-padding">
                            <input id="verificationCode" (keydown.space)="$event.preventDefault()"
                                (keydown.spacebar)="$event.preventDefault()" type="text" class="form-control"
                                formControlName="verificationCode" aria-required="true"
                                aria-describedby="verificationCodeHint"
                                oninput="this.value = this.value.replace(/\s/g, '')" />
                        </div>
                        <button type="button" class="btn btn-primary col-sm-4 mb-0 search-button"
                            [disabled]="!checkPermitForm.get('verificationCode')?.value" (click)="verifyCode()">
                            Verify Code
                        </button>
                    </div>
                    <!-- br instead of changing css -->
                    <div *ngIf="checkPermitForm.get('verificationCode')">
                        <div *ngIf="checkPermitForm.get('verificationCode')?.errors?.codeNotFound" role="alert"
                            tabindex="0" class="invalid-feedback">
                            {{ checkPermitForm.get('verificationCode')?.errors?.codeNotFound }}
                        </div>
                        <div *ngIf="
                      submitted && checkPermitForm.get('verificationCode')?.errors?.required
                    " class="invalid-feedback">
                            <div *ngIf="checkPermitForm.get('verificationCode')?.errors?.required" role="alert"
                                tabindex="0">
                                Verification code required
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row permit-data" *ngIf="foundPermit">
                <div class="permit-result card">
                    <div class="card-body">
                        <div class="header">
                            <h2 class="card-title">Permit Found</h2>
                            <span class="badge badge-pill" [ngClass]="dataTablesData['badge-colour']">{{
                                dataTablesData.status }}</span>
                        </div>
                        <div class="row permit-data">
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <div class="permit-data-item">
                                    <span class="label">
                                        <span class="label">Permit Type</span>
                                    </span>
                                    <span class="value">{{dataTablesData.type}}</span>
                                </div>
                            </div>
                            <br>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <div class="permit-data-item">
                                    <span class="label">
                                        <i class="fa fa-calendar-check"></i>
                                        <span class="label">Remaining Visits</span>
                                    </span>
                                    <span class="value">{{dataTablesData.annual_allowance}}</span>
                                </div>
                            </div>
                            <br>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <div class="permit-data-item">
                                    <span class="label">
                                        <i class="fa fa-car"></i>
                                        <span class="label">Vehicle Registration</span>
                                    </span>
                                    <span class="value">{{dataTablesData.vehicle_reg}}</span>
                                </div>
                            </div>
                            <br>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <div class="permit-data-item">
                                    <span class="label">
                                        <span class="label">Vehicle Make</span>
                                    </span>
                                    <span class="value">{{dataTablesData.vehicle_make}}</span>
                                </div>
                            </div>
                            <br>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <div class="permit-data-item">
                                    <span class="label">
                                        <span class="label">Vehicle Model</span>
                                    </span>
                                    <span class="value">{{dataTablesData.vehicle_model}}</span>
                                </div>
                            </div>
                            <br>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <div class="permit-data-item">
                                    <span class="label">
                                        <i class="fa fa-calendar-alt"></i>
                                        <span class="label">Permit Expiry Date</span>
                                    </span>
                                    <span class="value">{{dataTablesData.valid_to}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-primary col-sm-4 mb-0 search-button" (click)="showAuditHistory()"
                    *ngIf="!showingHistory">Show visit history</button>
                <button type="button" class="btn btn-primary col-sm-4 mb-0 search-button"
                    (click)="showingHistory = false" *ngIf="showingHistory">Hide visit history</button>

                <div *ngIf="showingHistory">
                    <div class="permit-result card">
                        <div class="card-body">
                            <div class="header">
                                <h2 class="card-title">Visit history</h2>
                            </div>
                            <div class="haf-children-review" style="max-height: 400px;overflow-y: scroll;">
                                <div class="row" style="border-bottom: 1px solid #ddd;">
                                    <div class="col-sm-6"><strong>Site</strong></div>
                                    <div class="col-sm-6"><strong>Date & Time</strong></div>
                                </div>
                                <div *ngFor="let history of history" class="row" style="border-bottom: 1px solid #ddd;">
                                    <div class="col-sm-6">{{history.siteName}}</div>
                                    <div class="col-sm-6">{{history.visitDate}} {{history.visitTime}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br />
    <br />
</div>